import React, { useEffect, useMemo, useRef, useState } from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { deleteCoupon } from "../../store/reducers/couponSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as SearchIcon } from "../../assets/icons/search-svgrepo-com (1).svg";
// import CreateIcon from "../../assets/icons/plus-circle-blue.svg";
// import EditIcon from "../../assets/icons/edit.svg";
import { ReactComponent as CreateIcon } from "../../assets/icons/plus-circle-blue.svg";
import { ReactComponent as BrandCreateIcon } from "../../assets/icons/brandCreateIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as BrandEditIcon } from "../../assets/icons/brandEditIcon.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import { getCouponDetails } from "../../utils/api/apis";
import { useTable, usePagination } from "react-table";
import { Pagination } from "@mui/material";
import { use } from "react";
import LoaderOverlay from "../Loader";

function CouponTable() {
  const idToken = useSelector((state) => state.auth.idToken);
  const [filteredCoupon, setFilteredCoupon] = useState(null);
  const [inputText, setInputText] = useState("");
  const [isDeleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [deleteConfirmationModalContent, setDeleteConfirmationModalContent] =
    useState(null);
  const [params, setParams] = useState({
    page: 1,
    page_size: 15,
    active: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const fetchCouponsList = async () => {
    try {
      setIsLoading(true);
      const response = await getCouponDetails(idToken, params);
      setFilteredCoupon(response); // Update the state with the fetched coupon data
    } catch (error) {
      console.error("Failed to fetch coupon details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const searchValue = e.target.querySelector("input").value; // Get input value from the form
    setParams((prev) => ({ ...prev, coupon: searchValue, page: 1 }));
    fetchCouponsList();
  };

  useEffect(() => {
    fetchCouponsList();
  }, [params]);
  const { selectedBrand } = useSelector((state) => state.brand);


  return (
    <div className="coupon_table">
      {isLoading && <LoaderOverlay />}

      <div className="table_scroll_wrapper">
        <Table
          inputText={inputText}
          setInputText={setInputText}
          handleSearchSubmit={handleSearchSubmit}
          coupon={filteredCoupon || { results: [], count: 0 }}
          setParams={setParams}
          params={params}
          setDeleteConfirmationModalOpen={setDeleteConfirmationModalOpen}
          setDeleteConfirmationModalContent={setDeleteConfirmationModalContent}
        />
        {isDeleteConfirmationModalOpen && (
          <DeleteModal
            fetchCouponsList={fetchCouponsList}
            isModalOpen={isDeleteConfirmationModalOpen}
            closeModal={() => setDeleteConfirmationModalOpen(false)}
            deleteContent={deleteConfirmationModalContent}
            idToken={idToken}
          />
        )}
      </div>
    </div>
  );
}

export default CouponTable;

// Table Component
const Table = ({
  inputText,
  setInputText,
  coupon,
  setParams,
  params,
  handleSearchSubmit,
  setDeleteConfirmationModalOpen,
  setDeleteConfirmationModalContent,
}) => {
  const navigate = useNavigate();
  const handleDeleteAction = (id) => {
    setDeleteConfirmationModalContent(id);
    setDeleteConfirmationModalOpen(true);
  };
  const { selectedBrand } = useSelector((state) => state.brand);
  const columns = React.useMemo(
    () => [
      {
        Header: "Code",
        accessor: "code",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Coupon %",
        accessor: "percent",
      },
      {
        Header: "Coupon Expiry",
        accessor: "expiry",
      },
      {
        Header: "Status",
        accessor: "is_active",
        Cell: ({ value }) => (
          <button className={value ? "Active_tag" : "Inactive_tag"}>
            {value ? "Active" : "Inactive"}
          </button>
        ),
      },
      {
        Header: "Public",
        accessor: "public",
        Cell: ({ value }) => (
          <button className={value ? "Active_tag" : "Inactive_tag"}>
            {value ? "True" : "False"}
          </button>
        ),
      },
      {
        Header: "",
        accessor: "delete",
        Cell: ({ row }) => (
          <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
            {/* <img
              onClick={() =>
                navigate(`/coupons/create-coupon/${row.original.id}`, {
                  state: row.original,
                })
              }
              src={EditIcon}
              alt="Edit"
              style={{ cursor: "pointer", height: "20px" }}
            /> */}
            <div
              onClick={() =>
                navigate(`/coupons/edit-coupon/${row.original.id}`, {
                  state: row.original,
                })
              }
              style={{ cursor: "pointer", height: "20px" }}
            >
              {selectedBrand?.brand === "crypto_edge" ? (
                <BrandEditIcon />
              ) : (
                <EditIcon />
              )}
            </div>

            <img
              onClick={() => handleDeleteAction(row.original.code)}
              src={DeleteIcon}
              alt="Delete"
              style={{ cursor: "pointer", height: "20px" }}
            />
          </div>
        ),
      },
    ],
    [coupon]
  );
  const data = useMemo(() => coupon.results, [coupon.results]);

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data: data || [],
        manualPagination: true, // Enable manual pagination
        initialState: { pageIndex: params.page - 1 }, // Initialize page index
      },
      usePagination
    );
  const handleFilter = (value) => {
    setParams((prev) => ({ ...prev, active: value, page: 1 }));
  };
  const [inputPage, setInputPage] = useState("");

  const handlePageChange = (_, page) => {
    setParams((prev) => ({ ...prev, page }));
  };

  const handleGoToPage = (e) => {
    e.preventDefault();

    const page = Number(inputPage);

    if (
      !page ||
      page < 1 ||
      page > Math.ceil(coupon.count / params.page_size)
    ) {
      alert("Please enter a valid page number.");
      return;
    }

    setParams((prev) => ({ ...prev, page }));
    setInputPage(""); // Clear the input after submission
  };

  return (
    <div className="table_wrapper">
      <div className="table_header">
        <form className="search_container" onSubmit={handleSearchSubmit}>
          <input
            type="text"
            placeholder="Search..."
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          />
          <button type="submit">
            <SearchIcon style={{ width: "20px", padding: "3px 10px 0 0" }} />
          </button>
        </form>
        <div className="filter_buttons">
          <div className="buttons">
            {" "}
            <button
              className={params.active === null ? "active_btn" : ""}
              onClick={() => handleFilter(null)}
            >
              All
            </button>
            <button
              className={params.active === "True" ? "active_btn" : ""}
              onClick={() => handleFilter("True")}
            >
              Active
            </button>
            <button
              className={params.active === "False" ? "active_btn" : ""}
              onClick={() => handleFilter("False")}
            >
              Inactive
            </button>
          </div>

          <Link to="/coupons/create-coupon">
            {" "}
            <div className="create_wrapper">
              {/* <img className="create_icon" src={CreateIcon} alt="create" /> */}
              {selectedBrand?.brand === "crypto_edge" ? (
                <BrandCreateIcon />
              ) : (
                <CreateIcon />
              )}
              <p>Create Coupon</p>
            </div>{" "}
          </Link>
        </div>
      </div>
      <div className="table_scroll">
        <table {...getTableProps()} className="leaderboard-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="spacerT30p">
        {coupon?.count > 0 ? (
          <div
            className="pagination_wrapper"
            style={{ display: "flex", alignItems: "center", gap: "20px" }}
          >
            <Pagination
              count={Math.ceil(coupon.count / params.page_size)} // Total pages
              page={params.page} // Current page
              onChange={handlePageChange}
              variant="outlined"
              color="primary"
            />
            <form onSubmit={handleGoToPage} className="goto-page-input">
              <input
                type="number"
                placeholder="Go to Page"
                value={inputPage}
                onChange={(e) => setInputPage(e.target.value)}
                min="1"
                max={Math.ceil(coupon.count / params.page_size)}
              />
              <button className="goToButton" type="submit">
                Go
              </button>
            </form>
          </div>
        ) : (
          <div
            style={{ display: "flex", width: "100%", justifyContent: "center" }}
          >
            No data
          </div>
        )}
      </div>
    </div>
  );
};

// DeleteModal Component
const DeleteModal = ({
  isModalOpen,
  closeModal,
  deleteContent,
  idToken,
  fetchCouponsList,
}) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteCoupon({ idToken, code: deleteContent }));
    closeModal();
  };

  return (
    <div className="confirmationModal_wrapper">
      <h2>Are you sure you want to delete this coupon?</h2>
      <div className="buttons_wrapper">
        <button className="confirm" onClick={handleDelete}>
          Confirm
        </button>
        <button className="cancel" onClick={closeModal}>
          Cancel
        </button>
      </div>
    </div>
  );
};
